import { render } from "./CreateCommissionInvoice.vue?vue&type=template&id=12487e88"
import script from "./CreateCommissionInvoice.vue?vue&type=script&lang=js"
export * from "./CreateCommissionInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__